import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import Datenschutz from './Views/Datenschutz'
import Main from './Views/Main'
import Impressum from './Views/Impressum'
import News from './Views/News'

Vue.config.productionTip = false;
Vue.use(VueRouter);

const routes = [
  { path: '/datenschutz', component: Datenschutz },
  { path: '/', component: Main},
  { path: '/impressum', component: Impressum},
  { path: '/neuigkeiten', component: News}
];
const router = new VueRouter({
  routes
});


new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app');


